// import packages
import gql from "graphql-tag"

// export gqls
export const GET_USERS = gql`
  query Users($take: Int, $skip: Int, $input: UserFilterInput) {
    users(take: $take, skip: $skip, input: $input) {
      total
      data {
        id
        name
        email
        title
        dept
        role
        areas
        isEnable
        company {
          id
          name
        }
        isPasswordNeedToChange
      }
    }
  }
`
export const SUM_USERS = gql`
  query User($input: UserFilterInput) {
    users(take: 0, input: $input) {
      total
    }
  }
`

export const GET_USER = gql`
  query User($id: ID!) {
    user(id: $id) {
      id
      name
      email
      title
      dept
      role
      areas
      isEnable
      company {
        id
        name
      }
      isPasswordNeedToChange
    }
  }
`

export const UPDATE_USER = gql`
  mutation UpdateUser($id: ID!, $input: UserUpdateInput!) {
    updateUser(id: $id, input: $input) {
      id
    }
  }
`

export const CREATE_USER = gql`
  mutation CreateUser($input: UserCreateInput!) {
    createUser(input: $input) {
      id
    }
  }
`

export const DELETE_USER = gql`
  mutation DeleteUser($id: ID!) {
    deleteUser(id: $id)
  }
`

export const GET_COMPANIES = gql`
  query Companies {
    companies {
      total
      data {
        id
        name
        area
      }
    }
  }
`
